(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cart-drawer]');
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id');

    function open() { root.classList.add('is-open'); document.body.classList.add('cart-open'); }
    function close() { root.classList.remove('is-open'); document.body.classList.remove('cart-open'); }

    function updateCount(count) {
      document.querySelectorAll('.header__cart-count').forEach(function (el) { el.textContent = count; el.hidden = count <= 0; });
      document.querySelectorAll('.header__cart').forEach(function (el) { el.setAttribute('aria-label', 'Basket (' + count + ')'); });
    }

    function replaceContent(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.querySelector('[data-cart-content]');
      var cur = root.querySelector('[data-cart-content]');
      if (next && cur) cur.innerHTML = next.innerHTML;
      var title = doc.querySelector('.cartd__title');
      var curTitle = root.querySelector('.cartd__title');
      if (title && curTitle) curTitle.textContent = title.textContent;
    }

    function refresh(openAfter) {
      fetch('/?sections=' + sectionId, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) { if (data[sectionId]) replaceContent(data[sectionId]); if (openAfter) open(); })
        .catch(function () { if (openAfter) open(); });
    }

    function changeLine(line, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: sectionId })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { updateCount(cart.item_count); if (cart.sections && cart.sections[sectionId]) replaceContent(cart.sections[sectionId]); });
    }

    // Open triggers (header cart icon)
    document.querySelectorAll('[data-cart-toggle], .header__cart').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });

    // Close triggers + Esc
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

    // Line item controls (delegated)
    root.addEventListener('click', function (e) {
      var stepBtn = e.target.closest('[data-cart-step]');
      var removeBtn = e.target.closest('[data-cart-remove]');
      if (stepBtn) {
        var lineEl = stepBtn.closest('[data-cart-line]');
        var input = lineEl.querySelector('[data-cart-qty]');
        var q = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(stepBtn.getAttribute('data-cart-step'), 10));
        changeLine(parseInt(lineEl.getAttribute('data-cart-line'), 10), q);
      } else if (removeBtn) {
        var line = removeBtn.closest('[data-cart-line]');
        changeLine(parseInt(line.getAttribute('data-cart-line'), 10), 0);
      }
    });
    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty]');
      if (input) {
        var line = input.closest('[data-cart-line]');
        changeLine(parseInt(line.getAttribute('data-cart-line'), 10), Math.max(0, parseInt(input.value, 10) || 0));
      }
    });

    // Intercept add-to-cart forms
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form');
      if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      e.preventDefault();
      var data = new FormData(form);
      data.append('sections', sectionId);
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
        .then(function (r) { return r.json(); })
        .then(function () { refresh(true); return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) { updateCount(cart.item_count); })
        .catch(function () {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cart-page]');
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id');

    function updateCount(count) {
      document.querySelectorAll('.header__cart-count').forEach(function (el) { el.textContent = count; el.hidden = count <= 0; });
      document.querySelectorAll('.header__cart').forEach(function (el) { el.setAttribute('aria-label', 'Basket (' + count + ')'); });
    }

    function replaceContent(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.querySelector('[data-cart-page-content]');
      var cur = root.querySelector('[data-cart-page-content]');
      if (next && cur) cur.innerHTML = next.innerHTML;
    }

    function changeLine(line, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: sectionId })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCount(cart.item_count);
          if (cart.sections && cart.sections[sectionId]) replaceContent(cart.sections[sectionId]);
        });
    }

    root.addEventListener('click', function (e) {
      var stepBtn = e.target.closest('[data-cart-step]');
      var removeBtn = e.target.closest('[data-cart-remove]');
      if (stepBtn) {
        var lineEl = stepBtn.closest('[data-cart-line]');
        var input = lineEl.querySelector('[data-cart-qty]');
        var q = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(stepBtn.getAttribute('data-cart-step'), 10));
        changeLine(parseInt(lineEl.getAttribute('data-cart-line'), 10), q);
      } else if (removeBtn) {
        e.preventDefault();
        var line = removeBtn.closest('[data-cart-line]');
        changeLine(parseInt(line.getAttribute('data-cart-line'), 10), 0);
      }
    });

    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty]');
      if (input) {
        var line = input.closest('[data-cart-line]');
        changeLine(parseInt(line.getAttribute('data-cart-line'), 10), Math.max(0, parseInt(input.value, 10) || 0));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.fp--carousel').forEach(function (root) {
    var track = root.querySelector('[data-fp-track]');
    var prev = root.querySelector('[data-fp-prev]');
    var next = root.querySelector('[data-fp-next]');
    if (!track || !prev || !next) return;
    function step() {
      var card = track.querySelector('.pcard, [class*="card"]');
      var w = card ? card.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
      return w;
    }
    function update() {
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["find-your-routine"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-fyr]');
    if (!root) return;

    var QUESTIONS = [
      { q: "What's your main goal?", options: [
        { title: "Protect my colour", desc: "Keep tone rich and fade at bay", weight: { 'colour-protect': 3 } },
        { title: "Repair & strengthen", desc: "Rebuild condition, reduce breakage", weight: { 'repair-strengthen': 3 } },
        { title: "Style & finish", desc: "Hold, smooth, texture, volume", weight: { 'style-finish': 3 } },
        { title: "Healthy scalp & cleanse", desc: "The right base for healthy hair", weight: { 'cleanse-scalp': 3 } }
      ] },
      { q: "How does your hair feel day to day?", options: [
        { title: "Dry or brittle", desc: "Thirsty, rough, snaps easily", weight: { 'repair-strengthen': 2 } },
        { title: "Oily or flat at the roots", desc: "Loses its freshness fast", weight: { 'cleanse-scalp': 2 } },
        { title: "Frizzy or hard to manage", desc: "Tricky to control or finish", weight: { 'style-finish': 1, 'repair-strengthen': 1 } },
        { title: "Healthy, just maintaining", desc: "Happy, keeping it that way", weight: { 'cleanse-scalp': 1 } }
      ] },
      { q: "Is your hair colour-treated?", options: [
        { title: "Yes, keeping it vibrant matters", desc: "Colour, balayage or highlights", weight: { 'colour-protect': 2 } },
        { title: "Yes, but low-maintenance", desc: "A little colour, easy-going", weight: { 'colour-protect': 1 } },
        { title: "No, it's my natural colour", desc: "No colour to protect", weight: { 'cleanse-scalp': 1 } }
      ] },
      { q: "How do you like to finish your hair?", options: [
        { title: "Natural and low-effort", desc: "Air-dry, minimal product", weight: { 'style-finish': 1 } },
        { title: "Smooth and sleek", desc: "Polished and frizz-free", weight: { 'style-finish': 2 } },
        { title: "Textured with hold", desc: "Definition and grip", weight: { 'style-finish': 2 } },
        { title: "I don't really style it", desc: "Wash and go", weight: {} }
      ] }
    ];
    var PRIORITY = ['cleanse-scalp', 'repair-strengthen', 'colour-protect', 'style-finish'];
    var RESULT_EYEBROW = root.querySelector('[data-fyr-result-eyebrow]').textContent.trim() || 'Your routine';

    var answers = [null, null, null, null];
    var current = 0;

    var stages = {};
    root.querySelectorAll('[data-fyr-stage]').forEach(function (el) { stages[el.getAttribute('data-fyr-stage')] = el; });
    var stepEl = root.querySelector('[data-fyr-step]');
    var qTextEl = root.querySelector('[data-fyr-qtext]');
    var optionsEl = root.querySelector('[data-fyr-options]');
    var nextBtn = root.querySelector('[data-fyr-next]');
    var eyebrowEl = root.querySelector('[data-fyr-result-eyebrow]');
    var scroller = root.querySelector('.fyr__scroll');

    function showStage(name) {
      Object.keys(stages).forEach(function (k) { stages[k].hidden = (k !== name); });
      if (scroller) scroller.scrollTop = 0;
    }

    function open() {
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-open');
    }
    function close() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-open');
    }
    function restart() {
      answers = [null, null, null, null];
      current = 0;
      showStage('intro');
    }

    function renderQuestion() {
      var q = QUESTIONS[current];
      stepEl.textContent = 'Question ' + (current + 1) + ' of ' + QUESTIONS.length;
      qTextEl.textContent = q.q;
      optionsEl.innerHTML = '';
      q.options.forEach(function (opt, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'fyr-opt' + (answers[current] === i ? ' is-selected' : '');
        btn.innerHTML = '<span class="fyr-opt__title">' + opt.title + '</span><span class="fyr-opt__desc">' + opt.desc + '</span>';
        btn.addEventListener('click', function () {
          answers[current] = i;
          optionsEl.querySelectorAll('.fyr-opt').forEach(function (o) { o.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          nextBtn.disabled = false;
        });
        optionsEl.appendChild(btn);
      });
      nextBtn.disabled = (answers[current] === null);
      nextBtn.textContent = (current === QUESTIONS.length - 1) ? 'See my routine' : 'Next';
      showStage('question');
    }

    function scoreConcern() {
      var totals = { 'colour-protect': 0, 'repair-strengthen': 0, 'style-finish': 0, 'cleanse-scalp': 0 };
      var q1 = null;
      answers.forEach(function (optIdx, qi) {
        if (optIdx == null) return;
        var w = QUESTIONS[qi].options[optIdx].weight;
        for (var k in w) { totals[k] += w[k]; }
        if (qi === 0) { q1 = Object.keys(w)[0]; }
      });
      var best = PRIORITY[0], bestScore = -1;
      PRIORITY.forEach(function (k) { if (totals[k] > bestScore) { bestScore = totals[k]; best = k; } });
      if (q1 && totals[q1] === bestScore) { best = q1; }
      return best;
    }

    function showResults() {
      var key = scoreConcern();
      var panels = root.querySelectorAll('.fyr-result');
      var label = '';
      panels.forEach(function (p) {
        var match = p.getAttribute('data-concern') === key;
        p.hidden = !match;
        if (match) { label = p.getAttribute('data-label') || ''; }
      });
      eyebrowEl.textContent = label ? (RESULT_EYEBROW + ' · ' + label) : RESULT_EYEBROW;
      showStage('results');
    }

    // Navigation
    root.querySelector('[data-fyr-start]').addEventListener('click', function () { current = 0; renderQuestion(); });
    nextBtn.addEventListener('click', function () {
      if (answers[current] === null) return;
      if (current === QUESTIONS.length - 1) { showResults(); }
      else { current++; renderQuestion(); }
    });
    root.querySelector('[data-fyr-back]').addEventListener('click', function () {
      if (current === 0) { showStage('intro'); }
      else { current--; renderQuestion(); }
    });
    root.querySelector('[data-fyr-restart]').addEventListener('click', restart);

    // Close
    root.addEventListener('click', function (e) { if (e.target.closest('[data-fyr-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

    // Adding to basket from the quiz: let the cart drawer handle the add, close the overlay so the drawer shows.
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form');
      if (form && root.contains(form) && /\/cart\/add/.test(form.getAttribute('action') || '')) {
        close();
      }
    });

    // Open triggers: any link to #find-your-routine, or [data-fyr-open]
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('a[href*="#find-your-routine"], [data-fyr-open]');
      if (!trigger) return;
      e.preventDefault();
      restart();
      open();
    });
    if (window.location.hash === '#find-your-routine') { restart(); open(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-pdp-gallery]').forEach(function (root) {
    var main = root.querySelector('[data-pdp-main]');
    root.querySelectorAll('[data-pdp-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (main) { main.srcset = ''; main.src = thumb.getAttribute('data-pdp-thumb'); }
        root.querySelectorAll('[data-pdp-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  document.querySelectorAll('.pdp').forEach(function (root) {
    var mainQty = root.querySelector('[data-pdp-qty-input]');
    var stickyQty = root.querySelector('[data-pdp-sticky-qty]');

    // Quantity steppers (both main + sticky drive the same submitted quantity)
    root.querySelectorAll('.pdp__qty').forEach(function (wrap) {
      var input = wrap.querySelector('.pdp__qty-input');
      wrap.querySelectorAll('[data-pdp-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-pdp-qty'), 10);
          var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = val;
          if (mainQty && stickyQty) { mainQty.value = val; stickyQty.value = val; }
        });
      });
    });
    if (stickyQty && mainQty) {
      stickyQty.addEventListener('input', function () { mainQty.value = Math.max(1, parseInt(stickyQty.value, 10) || 1); });
      mainQty.addEventListener('input', function () { stickyQty.value = Math.max(1, parseInt(mainQty.value, 10) || 1); });
    }

    // Sticky bar reveal — show once the main Add button is scrolled above the viewport
    var addBtn = root.querySelector('[data-pdp-add]');
    var sticky = root.querySelector('[data-pdp-sticky]');
    if (addBtn && sticky && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var below = e.boundingClientRect.top > 0; // button is below viewport (haven't reached it yet)
          sticky.classList.toggle('is-visible', !e.isIntersecting && !below);
          sticky.setAttribute('aria-hidden', (!e.isIntersecting && !below) ? 'false' : 'true');
        });
      }, { rootMargin: '0px 0px -40px 0px' });
      io.observe(addBtn);
    }

    // Variant selection → update id / price / availability on both main + sticky
    var script = root.querySelector('[data-pdp-variants]');
    if (!script) return;
    var variants;
    try { variants = JSON.parse(script.textContent); } catch (e) { return; }
    var idInput = root.querySelector('[data-pdp-id]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var stickyPrice = root.querySelector('[data-pdp-sticky-price]');
    var stickySize = root.querySelector('[data-pdp-sticky-size]');
    var buttons = [addBtn, root.querySelector('.pdp-sticky__add')];
    var groups = root.querySelectorAll('[data-pdp-opt-position]');

    function update() {
      root.querySelectorAll('.pdp__swatch').forEach(function (s) {
        var i = s.querySelector('input');
        s.classList.toggle('is-selected', !!(i && i.checked));
      });
      var variant = variants.find(function (v) {
        return Array.prototype.every.call(groups, function (g) {
          var pos = parseInt(g.getAttribute('data-pdp-opt-position'), 10);
          var checked = g.querySelector('input:checked');
          return checked && v.options[pos - 1] === checked.value;
        });
      });
      if (!variant) {
        buttons.forEach(function (b) { if (b) { b.disabled = true; b.textContent = 'Unavailable'; } });
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.innerHTML = variant.price;
      if (stickyPrice) stickyPrice.innerHTML = variant.price;
      if (stickySize) stickySize.textContent = variant.title;
      buttons.forEach(function (b) { if (b) { b.disabled = !variant.available; b.textContent = variant.available ? 'Add to basket' : 'Sold out'; } });
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('.pdp__swatch input')) update();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["salon-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var PANO_RATIO = 2.2; // wider than this opens in drag-to-pan mode

    function initGallery(root) {
      if (root.dataset.sgReady === '1') return;
      root.dataset.sgReady = '1';

      var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-sg-open]'));
      if (!tiles.length) return;

      // ---- Carousel ----
      var carousel = root.querySelector('[data-sg-carousel]');
      var track = root.querySelector('[data-sg-track]');
      if (carousel && track) {
        var prev = carousel.querySelector('[data-sg-prev]');
        var next = carousel.querySelector('[data-sg-next]');

        var step = function () {
          var tile = tiles[0];
          if (!tile) return track.clientWidth;
          var cs = getComputedStyle(track);
          var gap = parseFloat(cs.columnGap || cs.gap) || 16;
          return tile.getBoundingClientRect().width + gap;
        };
        var update = function () {
          var overflow = track.scrollWidth > track.clientWidth + 4;
          carousel.classList.toggle('sg-carousel--static', !overflow);
          var max = track.scrollWidth - track.clientWidth - 2;
          if (prev) prev.hidden = !overflow || track.scrollLeft <= 2;
          if (next) next.hidden = !overflow || track.scrollLeft >= max;
        };
        if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      }

      // Fallback for a tile whose ratio was neither uploaded nor declared:
      // measure the thumbnail so the lightbox can still spot a panorama.
      tiles.forEach(function (t) {
        if (parseFloat(t.dataset.sgRatio) > 0) return;
        var thumb = t.querySelector('.sg-tile__img');
        if (!thumb) return;
        var apply = function () {
          if (!thumb.naturalWidth || !thumb.naturalHeight) return;
          t.dataset.sgRatio = (thumb.naturalWidth / thumb.naturalHeight).toFixed(4);
        };
        if (thumb.complete) apply();
        else thumb.addEventListener('load', apply, { once: true });
      });

      // ---- Lightbox ----
      var lb = root.querySelector('[data-sg-lightbox]');
      if (!lb || typeof lb.showModal !== 'function') return;

      var img = lb.querySelector('[data-sg-img]');
      var counter = lb.querySelector('[data-sg-counter]');
      var hint = lb.querySelector('[data-sg-hint]');
      var stage = lb.querySelector('[data-sg-stage]');
      var lbPrev = lb.querySelector('[data-sg-lbprev]');
      var lbNext = lb.querySelector('[data-sg-lbnext]');
      var closeBtn = lb.querySelector('[data-sg-close]');
      var current = 0;
      var opener = null;

      function preload(i) {
        var t = tiles[i];
        if (!t) return;
        var p = new Image();
        if (t.dataset.sgSrcset) p.srcset = t.dataset.sgSrcset;
        p.src = t.dataset.sgFull;
      }

      function applyRatio(r) {
        var pano = r >= PANO_RATIO;
        lb.classList.toggle('sg-lb--pano', pano);
        if (hint) hint.hidden = !pano;
        img.width = 1600;
        img.height = Math.max(1, Math.round(1600 / r));
        img.sizes = pano ? Math.round(r * 100) + 'vh' : '100vw';
      }

      function show(i) {
        var total = tiles.length;
        current = (i + total) % total;
        var t = tiles[current];
        var known = parseFloat(t.dataset.sgRatio) > 0;

        applyRatio(known ? parseFloat(t.dataset.sgRatio) : 1.5);

        img.onload = known ? null : function () {
          if (!img.naturalWidth || !img.naturalHeight) return;
          var r = img.naturalWidth / img.naturalHeight;
          t.dataset.sgRatio = r;
          applyRatio(r);
          if (stage) stage.scrollLeft = 0;
        };

        img.removeAttribute('srcset');
        img.src = t.dataset.sgFull;
        if (t.dataset.sgSrcset) img.srcset = t.dataset.sgSrcset;
        img.alt = t.dataset.sgAlt || '';

        if (counter) counter.textContent = (current + 1) + ' / ' + total;
        var many = total > 1;
        if (lbPrev) lbPrev.hidden = !many;
        if (lbNext) lbNext.hidden = !many;
        if (stage) stage.scrollLeft = 0;

        preload(current + 1 >= total ? 0 : current + 1);
        preload(current - 1 < 0 ? total - 1 : current - 1);
      }

      var openedAt = 0;
      tiles.forEach(function (t, i) {
        t.addEventListener('click', function () {
          opener = t; show(i); lb.showModal();
          openedAt = performance.now();
        });
      });
      if (lbPrev) lbPrev.addEventListener('click', function () { show(current - 1); });
      if (lbNext) lbNext.addEventListener('click', function () { show(current + 1); });
      if (closeBtn) closeBtn.addEventListener('click', function () { lb.close(); });

      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); show(current - 1); }
      });

      // Click the backdrop to close, but ignore the second half of a
      // double-click on a tile, which would otherwise shut it straight away.
      lb.addEventListener('click', function (e) {
        if (performance.now() - openedAt < 350) return;
        if (e.target === lb || e.target === stage) lb.close();
      });

      lb.addEventListener('close', function () {
        if (opener && typeof opener.focus === 'function') opener.focus();
        opener = null;
      });

      // Swipe to page (skipped on panoramas, where dragging pans instead)
      var startX = 0, startY = 0, tracking = false;
      stage.addEventListener('touchstart', function (e) {
        if (lb.classList.contains('sg-lb--pano')) return;
        tracking = true; startX = e.touches[0].clientX; startY = e.touches[0].clientY;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(dx < 0 ? current + 1 : current - 1);
      }, { passive: true });

      // Drag to pan a panorama with a mouse
      var dragging = false, dragX = 0, dragScroll = 0;
      stage.addEventListener('mousedown', function (e) {
        if (!lb.classList.contains('sg-lb--pano')) return;
        dragging = true; dragX = e.clientX; dragScroll = stage.scrollLeft;
        stage.classList.add('is-dragging');
        e.preventDefault();
      });
      window.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        stage.scrollLeft = dragScroll - (e.clientX - dragX);
      });
      window.addEventListener('mouseup', function () {
        dragging = false;
        stage.classList.remove('is-dragging');
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-sg-gallery]').forEach(initGallery);
    }

    initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-team-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-team-track]');
    if (!track) return;
    var prev = root.querySelector('[data-team-prev]');
    var next = root.querySelector('[data-team-next]');

    function step() {
      var slide = track.querySelector('.tg-slide');
      return slide ? slide.getBoundingClientRect().width + 24 : track.clientWidth;
    }
    function update() {
      var overflow = track.scrollWidth > track.clientWidth + 4;
      root.classList.toggle('tg-carousel--static', !overflow);
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.hidden = !overflow || track.scrollLeft <= 2;
      if (next) next.hidden = !overflow || track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  document.querySelectorAll('[data-team-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var dialog = document.getElementById(btn.getAttribute('data-team-open'));
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    });
  });
  document.querySelectorAll('.tg-modal').forEach(function (dialog) {
    var closeBtn = dialog.querySelector('[data-team-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["visit-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SPEEDS = { slow: 12, medium: 19, brisk: 28 }; // pixels per second
    var RESUME_AFTER = 2000;                          // ms of stillness before it takes over again

    function initPano(root) {
      if (root.dataset.vpanoReady === '1') return;
      root.dataset.vpanoReady = '1';

      var view = root.querySelector('[data-vpano-viewport]');
      var img = root.querySelector('.vpano__img');
      var hint = root.querySelector('[data-vpano-hint]');
      if (!view || !img) return;

      var speed = SPEEDS[root.dataset.vpanoSpeed] || SPEEDS.medium;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      var dir = -1;          // start at the right edge and travel left
      var visible = true;
      var manualUntil = 0;
      var raf = null;
      var last = 0;
      var pos = 0;           // kept as a float so slow speeds do not stall on integer scrollLeft

      function maxScroll() { return Math.max(0, view.scrollWidth - view.clientWidth); }

      function toRightEdge() {
        pos = maxScroll();
        view.scrollLeft = pos;
      }

      function showHint() {
        if (!hint) return;
        hint.classList.add('is-visible');
        setTimeout(function () { hint.classList.remove('is-visible'); }, 2600);
      }

      function frame(now) {
        raf = requestAnimationFrame(frame);
        var dt = last ? Math.min((now - last) / 1000, 0.05) : 0;
        last = now;

        var max = maxScroll();
        if (max <= 0) return;
        if (!visible || reduced.matches || now < manualUntil) { pos = view.scrollLeft; return; }

        pos += dir * speed * dt;
        if (pos <= 0) { pos = 0; dir = 1; }
        else if (pos >= max) { pos = max; dir = -1; }
        view.scrollLeft = pos;
      }

      function start() { if (!raf) { last = 0; raf = requestAnimationFrame(frame); } }
      function stop() { if (raf) { cancelAnimationFrame(raf); raf = null; } }

      // Hand control to the visitor, then drift back in once they stop.
      function takeOver() { manualUntil = performance.now() + RESUME_AFTER; pos = view.scrollLeft; }

      var dragging = false, startX = 0, startLeft = 0;
      view.addEventListener('pointerdown', function (e) {
        dragging = true; startX = e.clientX; startLeft = view.scrollLeft;
        view.classList.add('is-dragging');
        view.setPointerCapture && view.setPointerCapture(e.pointerId);
        takeOver();
        if (e.pointerType === 'mouse') e.preventDefault();
      });
      view.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        view.scrollLeft = startLeft - (e.clientX - startX);
        takeOver();
      });
      function endDrag() {
        if (!dragging) return;
        dragging = false;
        view.classList.remove('is-dragging');
        takeOver();
      }
      view.addEventListener('pointerup', endDrag);
      view.addEventListener('pointercancel', endDrag);
      view.addEventListener('wheel', takeOver, { passive: true });
      view.addEventListener('touchstart', takeOver, { passive: true });
      view.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        view.scrollLeft += (e.key === 'ArrowRight' ? 60 : -60);
        takeOver();
      });

      // Only animate while it is on screen and the tab is in front.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          if (visible) { start(); showHint(); } else { stop(); }
        }, { threshold: 0.15 }).observe(root);
      } else {
        start();
      }
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });

      if (img.complete) toRightEdge();
      else img.addEventListener('load', toRightEdge, { once: true });
      window.addEventListener('resize', function () {
        if (performance.now() < manualUntil) return;
        pos = Math.min(pos, maxScroll());
      });
      start();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-vpano]').forEach(initPano);
    }
    initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
